import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { AppShell } from "../components/layout/AppShell";
import { LoadingState } from "../components/ui/State";
import { useAuth } from "../lib/auth";

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { status } = useAuth();

  if (status === "checking") {
    return (
      <div className="app-shell" style={{ gridTemplateColumns: "1fr", gridTemplateAreas: "'main'" }}>
        <main className="app-shell__main">
          <LoadingState />
        </main>
      </div>
    );
  }

  if (status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <AppShell>{children}</AppShell>;
}
